<div class="logout-container">
  <img priority ngSrc="/assets/herc-logo-yellow.svg" class="logo mb-2"
       alt="Herc Rentals logo" width="650" height="183">
  <p data-test-id="logout-message">
    You have been logged out of the OTG Damage application. Please click below to login
  </p>
  <div class="helpline">
    <button class="button-primary-yellow" data-test-id="login-button" (click)="loginAgain()">
      Login
    </button>
  </div>
</div>
